<template>
  <div id="box">
    <HeaderView></HeaderView>
    <img
      src="/img/contract/images/contactbanner_02.jpg"
      alt=""
      class="responsive-img"
    />
    <section class="section1">
      <h2 class="section-title">人力招聘</h2>
      <div class="section1box">
        <div class="tubiao-item">
          <img src="/img/contract/images/tubiao1_03.png" alt="" />
          <!-- <h3>激励创新新</h3>
          <div>
            <p>我们关注青年英才的培养</p>
            <p>我们关注青年英才的培养</p>
          </div> -->
        </div>
        <div class="tubiao-item">
          <img src="/img/contract/images/tubiao2_03.png" alt="" />
          <!-- <h3>激励创新新</h3>
          <div>
            <p>我们关注青年英才的培养</p>
            <p>我们关注青年英才的培养</p>
          </div> -->
        </div>
        <div class="tubiao-item">
          <img src="/img/contract/images/tubiao3_03.png" alt="" />
          <!-- <h3>激励创新新</h3>
          <div>
            <p>我们关注青年英才的培养</p>
            <p>我们关注青年英才的培养</p>
          </div> -->
        </div>
        <div class="tubiao-item">
          <img src="/img/contract/images/tubiao4_03.png" alt="" />
          <!-- <h3>激励创新新</h3>
          <div>
            <p>我们关注青年英才的培养</p>
            <p>我们关注青年英才的培养</p>
          </div> -->
        </div>
      </div>
    </section>

    <section class="section2">
      <h2 class="section-title">招聘信息</h2>
      <template>
        <el-table ref="table" :data="tableData" style="width: 100%" @row-click="handleRowClick">
          <el-table-column label="岗位名称" prop="position"> </el-table-column>
          <el-table-column label="所属部门" prop="department">
          </el-table-column>
          <el-table-column label="人数" prop="num"> </el-table-column>
          <el-table-column label="发布时间" prop="time"> </el-table-column>
          <el-table-column type="expand" fixed="right">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="岗位描述">
                  <div v-html="props.row.desc"></div>
                </el-form-item>
                <el-form-item label="岗位要求">
                  <div v-html="props.row.yaoqiu"></div>
                </el-form-item>
                <div>
                  <button @click.stop="openEmailClient">立刻投递</button>
                </div>
              </el-form>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </section>

    <section class="section2">
      <h2 class="section-title">联系方式</h2>
      <div
        id="mapContainer"
        class="map-container"
      ></div>
      
      <div class="contact-item">
        <div class="contact-title">售后服务热线</div>
        <div class="contact-info">
          <p>
            <img src="/img/contract/images/icon1_03.png" alt="" />
            
            地址：{{ copywriting.address }}
          </p>
          <p>
            <img src="/img/contract/images/icon2_03.png" alt="" />
            
            客服热线：{{ copywriting.tel }}
          </p>
          <p>
            <img src="/img/contract/images/icon3_03.png" alt="" />
            
            公司邮箱：{{ copywriting.email }}
          </p>
        </div>
      </div>
    </section>

    <section class="section3">
      <!-- <img src="/img/contract/images/formbg_02.png" alt=""> -->
      <div class="message-box">
        <div>
          <div class="contact-title">留言信息</div>
          <!-- <p>中国ESG优秀企业500强榜首</p> -->
        </div>
        <div class="form-wrapper">
          <form action="">
            <div class="form-group">
              <h3>基本信息</h3>
              <label>公司名称/个人</label>
              <input v-model="name" type="text" placeholder="请输入完整名称(公司/个人)" />
              <label>联系人</label>
              <input v-model="phone" type="text" placeholder="请输入您的姓名" />
              <label>移动电话/微信</label>
              <input v-model="email" type="text" placeholder="请输入您的电话/微信" />
            </div>
            <div class="form-group">
              <h3>需求信息</h3>
              <label>内容描述</label>
              <textarea
                v-model="message"
                placeholder="请输入您希望了解或希望购买的产品信息，我们将及时联系您"
                rows="4"
                style="height: 15rem; resize: none"
              ></textarea>
            </div>
            <button type="submit" @click.prevent="submitMessage">立刻提交</button>
          </form>
        </div>
      </div>
    </section>

    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "@/services/index.js";

import HeaderView from "../components/HeaderView2.vue";
import FooterView from "../components/FooterView.vue";

export default {
  components: {
    HeaderView,
    FooterView,
  },
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      message: '',
      copywriting: {},
      tableData: []
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.fetchData(),
    this.initMap();
  },
  methods: {
    handleRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    openEmailClient() {
      // window.location.href = 'mailto:hr@qdxyspyxgs.wecom.work';
      window.open('https://www.zhaopin.com/companydetail/CZ439821280.htm?refcode=4019&srccode=401903&preactionid=5981f492-3f18-417a-9e5b-3a3207ee3fed', '_blank');
    },
    fetchData() {
      apiServe.getRecruitmentData({}, 'get').then((res) => {
        this.tableData = res.data.map(item => ({
          id: item.id,
          position: item.name,
          department: item.department,
          num: item.number + '人',
          time: item.create_time,
          desc: item.description_content,
          yaoqiu: item.requirement_content
        }));
      });
      apiServe.getCopyWriting({}, "get").then((res) => {
        this.copywriting = res.data;
      })
    },
    submitMessage() {
      if (!this.name || !this.phone || !this.email || !this.message) {
        this.$message.error('请完整填写所有必填项');
        return;
      }
      let data = {
        company: this.name,
        name: this.phone,
        phone: this.email,
        content: this.message,
      }
      apiServe.postMessageData(data, 'post').then((res) => {
        this.$message.success('提交成功，我们将尽快与您联系');
        // 清空表单
        this.name = '';
        this.phone = '';
        this.email = '';
        this.message = '';
      });
    },

    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "51d2fec81048ad00da09ae501e2e4f43",
      };
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://webapi.amap.com/maps?v=2.0&key=51d2fec81048ad00da09ae501e2e4f43&callback=onAMapLoaded";
      document.head.appendChild(script);

      window.onAMapLoaded = () => {
        const map = new window.AMap.Map("mapContainer", {
          center: [120.321188,36.329993],
          zoom: 15,
        });

        const marker = new window.AMap.Marker({
          position: new window.AMap.LngLat(120.321188,36.329993),
          title: "青岛先优食品有限公司",
          //   icon: '/img/contract/images/red_03.png'
        });

        const text = new window.AMap.Text({
          text: '青岛先优食品有限公司',
          position: new window.AMap.LngLat(120.321188,36.329993),
          offset: new window.AMap.Pixel(-80,-70),
          style: {
            'background-color': 'white',
            'border': 'none',
            'font-size': '18px',
            'color': '#ED4856',
            'text-align': 'center',
            'white-space': 'nowrap'
          }
        });

        map.add(marker);
        map.add(text);
      };
    },
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>

<style scoped>
::v-deep(.el-table thead tr th) {
  font-weight: 400 !important;
  font-size: clamp(0.9rem, 3vw, 1.3rem);
  color: #fff;
}
::v-deep(.el-table thead th) {
  text-align: center;
  background-color: #14419e;
  padding: 1rem 0 !important;
}

::v-deep(.el-table .el-table__cell) {
  font-size: clamp(0.8rem, 2.5vw, 1.1rem);
  text-align: center;
  padding: 1rem 0;
}
/* ::v-deep(.el-table__expanded-cell) {
  padding: 1rem !important;
} */
::v-deep(.demo-table-expand .el-form-item) {
  display: block;
  margin-bottom: 1rem;
}
::v-deep(.demo-table-expand .el-form-item) {
  padding: 1rem 10rem!important;
}
::v-deep(.demo-table-expand .el-form-item__label) {
  position: relative;
  padding-left: 0.5rem;
  font-size: clamp(0.8rem, 2.5vw, 1rem);
  color: #000;
}
::v-deep(.demo-table-expand .el-form-item__label::before) {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 1em;
  background-color: #ed4856;
  margin-right: 0.3rem;
}
::v-deep(.demo-table-expand) {
  text-align: left;
}

.demo-table-expand {
  font-size: clamp(0.8rem, 2.5vw, 1rem);
}
.demo-table-expand label {
  width: 90px;
  color: #333;
  font-size: clamp(0.7rem, 2.2vw, 0.9rem);
}
.demo-table-expand p {
  font-size: clamp(0.8rem, 2.5vw, 1rem);
  line-height: 1.5;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
  padding: 0.25rem 0;
}
::v-deep(.demo-table-expand button) {
  all: unset;
  cursor: pointer;
  display: inline-block;
  color: #ed4856;
  border: 1px solid #ed4856;
  padding: 0.4rem 1.5rem;
  border-radius: 5px;
  box-sizing: border-box;
  margin-left: 75%;
  display: flex;
  justify-content: center;
}

::v-deep(.form-group input:focus),
::v-deep(.form-group textarea:focus) {
  outline: none;
}

.section1box {
  /* width: 90%; */
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10rem;
}
.tubiao-item {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  width: calc(50% - 1rem);
}
.tubiao-item > div p {
  font-size: clamp(0.8rem, 2.5vw, 1rem);
  color: #666;
}
.responsive-img {
  width: 100%;
  height: auto;
  display: block;
}

.section1 {
  padding: 3rem 1rem;
}
.section2 {
  padding: 2rem 1rem;
}
.map-container {
  width: 80%;
  margin: 0 auto;
  height: 400px;
  margin-top: 2rem;
}
.section3 {
  width: 100%;
  padding: 2rem 0;
  background-image: url(/public/img/contract/images/formbg_02.jpg);
  background-size: cover;
  background-position: center;
}
.message-box {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.message-box form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin: 0 auto;
}
.message-box > div p {
  color: #666;
  margin-top: 1rem;
}
.message-box input,
.message-box textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: clamp(0.9rem, 2.8vw, 1rem);
  box-sizing: border-box;
}
.message-box button {
  all: unset;
  cursor: pointer;
  color: #ed4856;
  border: 1px solid #ed4856;
  padding: 0.4rem 1.5rem;
  border-radius: 5px;
  text-align: center;
  width: fit-content;
  margin: 0 auto;
}

.form-wrapper {
  width: 100%;
  background-color: #fff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.form-group {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group h3 {
  position: relative;
  padding-left: 0.8rem;
  margin-bottom: 0.5rem;
  font-size: clamp(0.9rem, 3vw, 1.1rem);
  color: #ed4856;
  letter-spacing: 0.1rem;
}
.form-group label {
  font-size: clamp(0.8rem, 2.5vw, 1rem);
  color: #333;
  margin-bottom: 0.2rem;
}

.form-group h3::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 1em;
  background-color: #ed4856;
}
.section-title {
  font-size: clamp(1.5rem, 6vw, 2.8rem);
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 400;
  font-family: "Source Han Sans SC", "OPPOSANS-R", sans-serif;
}
.contact-item {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 3rem auto;
  gap: 1.5rem;
}
.contact-title {
  font-size: clamp(1.2rem, 4vw, 2rem);
  font-weight: 500;
  flex: 1;
  letter-spacing: 0.1rem;
}
.contact-info {
  font-size: clamp(0.9rem, 3vw, 1.2rem);
  line-height: 1.6;
  color: rgb(117, 116, 116);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.contact-info p {
  display: flex;
  align-items: center;
}
.contact-info img {
  margin-right: 0.5rem;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}
@media (max-width: 768px) {
  .map-container {
    width: 95%;
  }
  .section1box {
    gap: 2rem;
  }
  .demo-table-expand .el-form-item {
    padding: 0rem !important;
}
.form-wrapper {
    width: auto;
}
} 
@media (min-width: 768px) {
 
  .section1 {
    padding: 5rem 10rem;
  }
  .section2 {
    padding: 2rem 10rem;
  }
  .message-box {
    width: 68%;
    flex-direction: row;
  }
  .message-box form {
    width: 80%;
  }
  .form-wrapper {
    width: 55%;
    padding: 2rem;
  }
  .form-group {
    gap: 0.8rem;
    margin-bottom: 1.5rem;
  }
  .tubiao-item {
    width: auto;
  }
  .contact-item {
    flex-direction: row;
    width: 82%;
    margin: 5rem auto;
    gap: 2rem;
  }
}
</style>